module.exports = __webpack_public_path__ + "img/calendar.283533dc.png";